import { Button, Form, notification, Popconfirm } from "antd";
import React, { useState } from "react";
import { MultiLanguageInput } from "../../../Components/MultiLanguageInput";
import { PiPlus } from "react-icons/pi";
import { addNewMainWebsiteCategory } from "../actions";
import { useParams } from "react-router-dom";

type Props = {
  fetchData: () => void;
};

interface FormValues {
  category: {
    en: string;
    ar: string;
    fr: string;
  };
}

const AddNewCategory: React.FC<Props> = ({ fetchData }) => {
  const { id } = useParams();
  const [form] = Form.useForm<FormValues>();
  const [api, contextHolder] = notification.useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      const formValues = await form.validateFields();
      setIsLoading(true);

      const data = await addNewMainWebsiteCategory(id!, formValues.category);

      if (data) {
        form.resetFields();
        fetchData();
        api.success({
          message: "Category added successfully",
        });
      }
    } catch (err: any) {
      api.error({
        message: "Failed to add category",
        description:
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Unexpected error occurred",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Form form={form} layout="vertical">
      {contextHolder}

      <MultiLanguageInput name="category" label="Category" />

      <Form.Item shouldUpdate>
        {() => (
          <Popconfirm
            title="Are you sure you want to add this category?"
            onConfirm={handleSubmit}
            okText="Yes"
            cancelText="No"
          >
            <Button
              icon={<PiPlus />}
              loading={isLoading}
              type="primary"
              className="w-full"
              disabled={
                !form.isFieldsTouched(true) ||
                form.getFieldsError().some(({ errors }) => errors.length > 0)
              }
            >
              {isLoading ? "Adding Category..." : "Add Category"}
            </Button>
          </Popconfirm>
        )}
      </Form.Item>
    </Form>
  );
};

export default AddNewCategory;
